import React  from 'react';
import createStyles from '../../create-styles';

export default class Branding extends React.Component {
    state = {
        company: null
    };

    static getDerivedStateFromProps( nextProps, prevState ) {
        if ( nextProps.company !== prevState.company ) {
            const company = nextProps.company;
            createStyles( company, 'head' );
            window.branding = window.branding || {};
            window.branding.companyBranding = {
                primaryColor: company.primaryColor,
                secondaryColor: company.secondaryColor
            };
            return { company: nextProps.company };
       }
       else {
           return null;
        }
     }

    render() {
        return this.props.children;
    }
}
